import { render, staticRenderFns } from "./NevronConfirm.vue?vue&type=template&id=04fc5ac7&"
import script from "./NevronConfirm.vue?vue&type=script&lang=ts&"
export * from "./NevronConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports